import {axios, HOST, config} from './settiing';

export default {
  getUserRouteList() {
    return axios.get(`${HOST}/resource/role/admin`, config);
	},
	
	getAdminRoleByCenterId() {
		return axios.get(`${HOST}/resource/role/admin/center`, config);
	},

	getAdminRoleById(id) {
		return axios.get(`${HOST}/resource/role/admin/${id}`, config);
	},

  postAdminRole(data) {
		return axios.post(`${HOST}/resource/role/admin`, data, config);
  },

  deleteAdminRole(id) {
		return axios.delete(`${HOST}/resource/role/admin/${id}`, config);
  },

  getCenterRouteList() {
    return axios.get(`${HOST}/resource/centerRole/center`, config);
  },
}